import {Subject, Subscription} from 'rxjs';
import {catchError, startWith, takeWhile} from 'rxjs/operators';

export enum BdLoaderState {
  'INIT',
  'LOADING',
  'SUCCESS',
  'ERROR'
}

export abstract class BdLoader<R> {

  public readonly state$ = new Subject<BdLoaderState>();

  public abstract connect(loadItem: R): void;

  public destroy(): void {
    this.state$.unsubscribe();
  }
}

export class BdPromiseLoader extends BdLoader<Promise<unknown>> {

  constructor() {
    super();
  }

  connect(loadItem: Promise<unknown>): void {
    this.state$.next(BdLoaderState.LOADING);

    loadItem
      .then(() => this.state$.next(BdLoaderState.SUCCESS))
      .catch(() => this.state$.next(BdLoaderState.ERROR));
  }
}

export class BdSubjectLoader extends BdLoader<Subject<BdLoaderState>> {

  private _loadSubscription: Subscription | undefined;

  constructor() {
    super();
  }

  connect(loadItem: Subject<BdLoaderState>): void {
    this._loadSubscription = loadItem
      .pipe(
        startWith(BdLoaderState.INIT),
        catchError(error => {
          this.state$.next(BdLoaderState.ERROR);

          return error;
        }),
        takeWhile(value => !(value instanceof Error))
      )
      .subscribe(state => this.state$.next(state as BdLoaderState));
  }

  public override destroy(): void {
    super.destroy();

    if (this._loadSubscription) {
      this._loadSubscription.unsubscribe();
    }
  }
}
